import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import CustomFieldsList from './routes/CustomFieldsList';

const CustomFieldsLazy = React.lazy(
	() => import(/* webpackChunkName : 'CustomFields' */ './components')
);

export default (store) => {
	return [
		{
			path: 'custom-fields',
			element: <AsyncLoading component={<CustomFieldsLazy />} />,
			children: [CustomFieldsList(store)],
		},
	];
};
